import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar_old";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";

const API = "https://rishtey.rishteymatch.in/api2";      // API calls
const BASE_URL = "https://rishtey.rishteymatch.in";      // images

const MyProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  const loggedUser = JSON.parse(localStorage.getItem("currentUser")) || {};

  const currentUser = {
    canChat: loggedUser?.can_chat || false,
    canCall: loggedUser?.can_call || false,
  };

  // ================= FETCH USER =================
  const fetchUser = async () => {
    if (!loggedUser?._id) {
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/api/user/${loggedUser._id}`);
      if (res.data.success && res.data.user) setUser(res.data.user);
    } catch (err) {
      console.error("Fetch user error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // ================= HANDLE FIELD CHANGE =================
  const handleChange = (field, value) => {
    setUser((prev) => ({ ...prev, [field]: value }));
  };

  // ================= HANDLE IMAGE CHANGE =================
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) handleChange("image", file);
  };

  // ================= SAVE PROFILE =================
  const handleSave = async () => {
    if (!user) return;
    setSaving(true);

    try {
      const data = new FormData();

      Object.keys(user).forEach((key) => {
        const value = user[key];
        if (value !== undefined && value !== null) {
          if (value instanceof File) data.append(key, value);
          else data.append(key, value);
        }
      });

      const res = await axios.put(`${API}/api/user/${user._id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("✅ Profile updated successfully!");
        setEditing(false);
        fetchUser();
      } else {
        alert("❌ Update failed. Check console.");
        console.log(res.data);
      }
    } catch (err) {
      console.error("Server error:", err);
      alert("❌ Server error. Try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-warning"></div>
      </div>
    );

  if (!user)
    return (
      <div className="text-center mt-5 text-danger">
        <h5>User not found! Please login again.</h5>
      </div>
    );

  // ===== FIXED IMAGE LOGIC =====
  const profileImage = (() => {
    if (user.image instanceof File) return URL.createObjectURL(user.image);
    if (!user.image) return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    if (user.image.startsWith("http")) return user.image;
    // ensure single slash between BASE_URL and image path
    return `${BASE_URL.replace(/\/$/, "")}/${user.image.replace(/^\//, "")}`;
  })();

  // ================= DATA ARRAYS =================
  const personalDetails = [
    { label: "Full Name", field: "full_name", icon: "bi-person" },
    { label: "Marital Status", field: "marital_status", icon: "bi-people" },
    { label: "Gender", field: "gender", icon: "bi-gender-male" },
    { label: "Color", field: "color", icon: "bi-droplet" },
    { label: "Age", field: "age", icon: "bi-egg" },
    { label: "Height", field: "height", icon: "bi-rulers" },
    { label: "Weight", field: "weight", icon: "bi-barbell" },
    { label: "Diet", field: "diet", icon: "bi-egg-fried" },
    { label: "Disability", field: "disability", icon: "bi-toggle-on" },
    { label: "Blood Group", field: "blood_group", icon: "bi-circle-fill" },
    { label: "Profile Created By", field: "profile_created_by", icon: "bi-person-circle" },
    { label: "Country", field: "country", icon: "bi-flag" },
    { label: "State", field: "user_state", icon: "bi-compass" },
    { label: "City", field: "city", icon: "bi-map" },
    { label: "Town", field: "town", icon: "bi-key" },
  ];

  const careerDetails = [
    { label: "Education", field: "education", icon: "bi-award" },
    { label: "Education Detail", field: "education_detail", icon: "bi-info-circle" },
    { label: "Profession", field: "profession", icon: "bi-person-badge" },
    { label: "Occupation", field: "occupation", icon: "bi-briefcase" },
    { label: "Occupation Detail", field: "occupation_detail", icon: "bi-info-circle" },
    { label: "Annual Income", field: "income", icon: "bi-wallet2" },
  ];

  const familyDetails = [
    { label: "Father Name", field: "father_name", icon: "bi-person" },
    { label: "Father Occupation", field: "father_occupation", icon: "bi-briefcase" },
    { label: "Mother Name", field: "mother_name", icon: "bi-person-circle" },
    { label: "Mother Occupation", field: "mother_occupation", icon: "bi-briefcase" },
    { label: "Married Brothers", field: "married_brothers", icon: "bi-people-fill" },
    { label: "Unmarried Brothers", field: "unmarried_brothers", icon: "bi-people" },
    { label: "Married Sisters", field: "married_sisters", icon: "bi-people-fill" },
    { label: "Unmarried Sisters", field: "unmarried_sisters", icon: "bi-people" },
    { label: "House", field: "house", icon: "bi-house" },
    { label: "Car", field: "car", icon: "bi-car-front" },
  ];

  const contacts = [
    { label: "Mobile", field: "mobile", icon: "bi-telephone" },
    { label: "Father Contact", field: "father_contact", icon: "bi-telephone"},
    { label: "Whatsapp", field: "whatsapp", icon: "bi-whatsapp"},
    { label: "Email", field: "email", icon: "bi-envelope"},
    { label: "Present Address", field: "present_address", icon: "bi-geo-alt"},
    { label: "Permanent Address", field: "permanent_address", icon: "bi-key"},
  ];

  return (
    <>
      <Navbar />
      <div className="min-vh-100 py-4" style={{ background: "linear-gradient(135deg,#1f1c2c,#928dab)" }}>
        <div className="container">

          {/* PROFILE HEADER */}
          <div className="card p-4 rounded-4 shadow-lg mb-4 text-center" style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.1)" }}>
            <div className="mx-auto mb-3 position-relative" style={{ width: "150px", height: "150px" }}>
              <img src={profileImage} alt="profile" style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", background: "#000" }} />
              {editing && (
                <input
                  type="file"
                  accept="image/*"
                  className="position-absolute bottom-0 start-50 translate-middle-x form-control form-control-sm mt-2"
                  onChange={handleImageChange}
                />
              )}
            </div>

            <h3 className="fw-bold mb-1 text-white">{user.full_name || user.username}</h3>

            <div className="mt-3">
              <button className={`btn ${editing ? "btn-success" : "btn-warning"} btn-sm px-4`} onClick={() => editing ? handleSave() : setEditing(true)} disabled={saving}>
                {editing ? (saving ? "Saving..." : "Save Changes") : "Edit Profile"}
              </button>
              {editing && (
                <button className="btn btn-secondary btn-sm ms-2" onClick={() => setEditing(false)}>
                  Cancel
                </button>
              )}
            </div>
          </div>

          {/* SECTIONS */}
          <Section title="Personal Details" data={personalDetails} user={user} editing={editing} handleChange={handleChange} />
          <Section title="Career Details" data={careerDetails} user={user} editing={editing} handleChange={handleChange} />
          <Section title="Family Details" data={familyDetails} user={user} editing={editing} handleChange={handleChange} />

          {/* CONTACTS */}
          <div className="card bg-dark text-white p-3 rounded-4 mb-5">
            <h5 className="text-warning mb-3"><i className="bi bi-shield-lock-fill me-2"></i> Contact Details</h5>
            <div className="row">
              {contacts.map((item, i) => (
                <div className="col-md-6" key={i}>
                  <InfoLine icon={item.icon} label={item.label} value={user[item.field]} editing={editing && !item.lock} field={item.field} handleChange={handleChange} lock={item.lock} />
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

// ===== Section Component =====
const Section = ({ title, data, user, editing, handleChange }) => (
  <div className="card bg-dark text-white p-3 rounded-4 mb-4">
    <h5 className="text-warning mb-3">{title}</h5>
    <div className="row">
      {data.map((item, i) => (
        <div className="col-md-6" key={i}>
          <InfoLine icon={item.icon} label={item.label} value={user[item.field]} editing={editing} field={item.field} handleChange={handleChange} />
        </div>
      ))}
    </div>
  </div>
);

// ===== InfoLine Component =====
const InfoLine = ({ icon, label, value, editing, field, handleChange, lock }) => (
  <div className="d-flex justify-content-between py-2 border-bottom border-secondary align-items-center">
    <span><i className={`bi ${icon} me-2 text-warning`}></i> {label}</span>
    {editing && !lock ? (
      <input type="text" className="form-control form-control-sm ms-2" value={value || ""} onChange={(e) => handleChange(field, e.target.value)} />
    ) : (
      <span className={`fw-semibold ${lock ? "text-danger" : ""}`}>{lock ? "🔒 Upgrade to view" : value || "Not Filled"}</span>
    )}
  </div>
);

export default MyProfile;
